import { openBlock as e, createElementBlock as o } from "vue";
/* empty css                    */
/* empty css                    */
import t from "./design-system.es128.js";
const r = {
  name: "DsMenuDivider"
}, n = { class: "ds-menu-divider" };
function s(c, i, d, a, p, _) {
  return e(), o("div", n);
}
const v = /* @__PURE__ */ t(r, [["render", s], ["__scopeId", "data-v-170e62fa"]]);
export {
  v as default
};
//# sourceMappingURL=design-system.es70.js.map
